module.exports = __webpack_public_path__ + "img/interier.7281caa.png";